<template>
  <div>
    <div v-if="version!='horiz'">  
      <div v-if="realData.length>3">
        <div class="ui-pro-box">
          <Scroll class="table-warp" :dataList="realData" type='rec-list' @getMoreRec='getMoreRec'>
            <div slot="list" class="table-item">
              <div class="ui-recent-list box-bg mar-t2" v-for="(item,key) in realData" :key="key" :data-index="key">
                <div class="ui-flex flex-ac flex-bw">
                  <div class="ui-flex-c">
                    <div class="font-14 color-ff">{{item.projectName}}</div>
                  </div>
                  <p class="font-12 color-ff font-nowrap">{{item.createTime}}</p>
                </div>
                <div class="ui-flex flex-ac flex-bw">
                  <p class="font-12 col-67 mar-t1 dev-addr">设备位置：{{item.addrs}}</p>
                  <p class="font-14 font-nowrap" :class="item.orderStatus=='待派单'?'col-FE':(item.orderStatus=='待服务'?'col-Fb':'col-A5')">{{item.orderStatus}}</p>
                </div>
              </div>
            </div>
          </Scroll>
        </div> 
      </div>
      <div v-else>
        <div class="ui-recent-list box-bg mar-t2" v-for="(item,key) in realData" :key="key" :data-index="key">
          <div class="ui-flex flex-ac flex-bw">
            <div class="ui-flex-c">
              <div class="font-14 color-ff">{{item.projectName}}</div>
            </div>
            <p class="font-12 color-ff font-nowrap">{{item.createTime}}</p>
          </div>
          <div class="ui-flex flex-ac flex-bw">
            <p class="font-12 col-67 mar-t1 dev-addr">设备位置：{{item.addrs}}</p>
            <p class="font-14 font-nowrap" :class="item.orderStatus=='待派单'?'col-FE':(item.orderStatus=='待服务'?'col-Fb':'col-A5')">{{item.orderStatus}}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div  v-if="realData.length>2">
        <div class="ui-pro-box">
          <Scroll class="table-warp" :dataList="realData" type='rec-list' @getMoreRec='getMoreRec'>
            <div slot="list" class="table-item">
              <div class="ui-recent-list" :class="key==0?'mar-t1':'mar-t2'" v-for="(item,key) in realData" :key="key" :data-index="key">
                <!-- <div class="ui-flex flex-ac flex-bw">
                  <div class="ui-flex-c">
                    <div class="font-14 color-ff">{{item.projectName}}</div>
                  </div>
                  <p class="font-12 color-ff font-nowrap">{{item.createTime}}</p>
                </div>
                <div class="ui-flex flex-ac flex-bw">
                  <p class="font-12 col-67 mar-t1 dev-addr">设备位置：{{item.addrs}}</p>
                  <p class="font-14 font-nowrap" :class="item.orderStatus=='待派单'?'col-FE':(item.orderStatus=='待服务'?'col-Fb':'col-A5')">{{item.orderStatus}}</p>
                </div> -->
                <div class="ui-flex font-14" v-if="pageType == 'home'">
                    <div class="flex-1 text-c" >{{item.projectName}}</div>
                    <div class="flex-1 text-c">{{item.addrs}}</div>
                    <div class="flex-1 text-c"><p class="font-14 font-nowrap" :class="item.orderStatus=='待派单'?'col-FE':(item.orderStatus=='待服务'?'col-Fb':'col-A5')">{{item.orderStatus}}</p></div>
                    <div class="flex-1 text-c">{{item.createTime}}</div>
                </div>
                <div class="ui-flex font-14" v-else>
                  <div class="flex-1 text-c">{{item.equipPlace}}</div> 
                  <div class="flex-1 text-c"><p class="font-14 font-nowrap" :class="item.orderStatusName=='待派单'?'col-FE':(item.orderStatusName=='待服务'?'col-Fb':'col-A5')">{{item.orderStatusName}}</p></div>
                  <div class="flex-1 text-c">{{item.serviceItemNameList}}</div>
                  <div class="flex-1 text-c">{{maskName(item)}}</div>
                  <div class="flex-1 text-c">{{item.orderOpTime}}</div>
                </div>
              </div>
            </div>
          </Scroll>
        </div> 
      </div>
      <div v-else>
        <div class="ui-recent-list" :class="key==0?'mar-t1':'mar-t2'" v-for="(item,key) in realData" :key="key" :data-index="key">
          <!-- <div class="ui-flex flex-ac flex-bw">
            <div class="ui-flex-c">
              <div class="font-14 color-ff">{{item.projectName}}</div>
            </div>
            <p class="font-12 color-ff font-nowrap">{{item.createTime}}</p>
          </div>
          <div class="ui-flex flex-ac flex-bw">
            <p class="font-12 col-67 mar-t1 dev-addr">设备位置：{{item.addrs}}</p>
            <p class="font-14 font-nowrap" :class="item.orderStatus=='待派单'?'col-FE':(item.orderStatus=='待服务'?'col-Fb':'col-A5')">{{item.orderStatus}}</p>
          </div> -->
          <div class="ui-flex" v-if="pageType == 'home'">
              <div class="flex-1 text-c">{{item.projectName}}</div>
              <div class="flex-1 text-c">{{item.addrs}}</div> 
              <div class="flex-1 text-c"><p class="font-14 font-nowrap" :class="item.orderStatus=='待派单'?'col-FE':(item.orderStatus=='待服务'?'col-Fb':'col-A5')">{{item.orderStatus}}</p></div>
              <div class="flex-1 text-c">{{item.createTime}}</div>
          </div>
          <div class="ui-flex" v-else> 
            <div class="flex-1 text-c">{{item.equipPlace}}</div> 
            <div class="flex-1 text-c"><p class="font-14 font-nowrap" :class="item.orderStatusName=='待派单'?'col-FE':(item.orderStatusName=='待服务'?'col-Fb':'col-A5')">{{item.orderStatusName}}</p></div>
            <div class="flex-1 text-c">{{item.serviceItemNameList}}</div>
            <div class="flex-1 text-c">{{maskName(item)}}</div>
            <div class="flex-1 text-c">{{item.orderOpTime}}</div>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import Scroll from "./Scroll";
import { reqGetRecentList } from '@/api'
export default {
  props: {
    recentInfo:{
      type:Object,
      default:{}
    },
    recentList: {
      type: Array,
      default: []
    },
    // 设备，项目页传值
    pageType:{
      type:String,
    },
    // 横竖版
    version:{
      type:String,
    } 
  }, 
  components: {
    Scroll
  }, 
  watch:{
    recentList(newVal){ 
      this.realData = newVal;   
    }, 
  },
  data(){
    return{
      queryParams:{ 
          pageNum:2,
          pageSize:10,
          startColumnNum:10,//开始行号
      }, 
      realData:this.recentList
    }
  },
  mounted(){  
    if(this.pageType == 'home')this._initData() 
  },
  methods:{
    maskName(item) {
      const name = item.leaderName || item.leaderEmployeeName || '';
      if (!name || name.length <= 1) return name;
      return name.charAt(0) + '*'.repeat(name.length - 1);
    },
    _initData(){//初始化基本数据 
      if(JSON.parse(localStorage.getItem('locParams'))){
        this.queryParams.code=JSON.parse(localStorage.getItem('locParams')).code;
        this.queryParams.level=JSON.parse(localStorage.getItem('locParams')).level; 
        this.queryParams.pageNum=1; 
        this.queryParams.startColumnNum=0;   
      } else {
        let user=JSON.parse(localStorage.getItem('user'))
        const { customerLevel,bindCode,provinceCode,areaCode,cityCode,provinceName,cityName,areaName }=user
        let code="",level="",location=""
        if(customerLevel==4|| customerLevel==5){//国家
            code = '';
            level = 'country';
            location="中国"
        }else if(customerLevel==3){//省
            code = provinceCode;
            level = 'province';
            location=provinceName  
        }else if(customerLevel==2){//市
            code = cityCode;
            level = 'city'; 
            location=cityName 
        }else if(customerLevel==1){//区
            code = areaCode;
            level = 'area'; 
            location=areaName 
        } 
        this.queryParams.code =code
        this.queryParams.level=level 
        this.queryParams.bindCode=bindCode  
      }
    }, 
    getMoreRec() {
        let pageTotal = Math.ceil(this.recentInfo.totalNum / 10) // 最大页数
        if (this.queryParams.pageNum < pageTotal) {
          // 现有总数小于所有总数
          this.queryParams.pageNum++
          this.queryParams.startColumnNum = this.queryParams.pageSize*(this.queryParams.pageNum-1);  
        } else if (this.queryParams.pageNum == pageTotal) {
          this.queryParams.pageNum = 1;
          this.queryParams.startColumnNum = 0;
        }
        // if(this.pageType == 'home')this.getdata() // 请求数据
    }, 
    getdata(){  
      if(localStorage.getItem('projectSortIdList')){
        this.queryParams.projectSortIdList = JSON.parse(localStorage.getItem('projectSortIdList'));
      } 
      return new Promise((reslove,reject)=>{
        reqGetServiceInfo(this.queryParams).then(res=>{
          if(res.success){
            reslove(true)  
            this.recentInfo.totalNum = res.data.totalNum; 
            let list;
            list = res.data.orderInfoVoList; 
            list.map(item=>{ 
              item.addrs = [];  
              if(item.equipInfoVoList && item.equipInfoVoList.length>0){ 
                for(let i = 0;i<item.equipInfoVoList.length;i++){  
                    item.addrs.push(item.equipInfoVoList[i].equipPlace)
                }  
              } else {
                if(item.equipPlace){
                    item.addrs.push(item.equipPlace)
                }
              } 
              item.addrs = item.addrs.join();    
            })
            if(this.queryParams.pageNum==1){
              this.realData = list; 
            } else { 
              if(list.length<10 && this.queryParams.pageNum!=1){
                this.queryParams.pageNum = 1;
                this.queryParams.startColumnNum = 0;
                this.getdata() 
              } else { 
                // this.realData = list; 
                this.realData = this.realData.concat(list); 
              }
            } 
          } else {
            reslove(false)
          }
        })
      })
    },
    toPage(e){  
      // devinfo 设备页 跳转详情；其他页面跳转近期服务页面
      let items = e.target.closest(".ui-recent-list");//防止复制的事件不能点击
      if(!items)return; 
      let item = this.realData[items.dataset.index] 
      let queryParams = {
        orderCode:item.orderCode,
        equipCode:item.equipCode,
        orderLineCode:item.orderLineCode, 
        projectCode:item.projectCode, 
      } 
      let proInfo = { 
        'projectName':item['projectName'],
        'projectCode':item['projectCode'],
      } 
      localStorage.setItem('proDevMsg',JSON.stringify(proInfo));
      if(this.version == 'vertical'){//竖版
        if(this.pageType == 'devinfo'){
          this.$router.push(`/orderDetail?orderCode=${item.orderCode}&equipCode=${item.equipCode}&orderLineCode=${item.orderLineCode}&projectCode=${item.projectCode}&version=vertical`)
        } else {
          this.$router.push(`/recentServ?queryParams=`+JSON.stringify(queryParams)+'&pageType=pro')
        } 
      } else {
        if(this.pageType == 'devinfo'){
          this.$router.push(`/orderDetail?orderCode=${item.orderCode}&equipCode=${item.equipCode}&orderLineCode=${item.orderLineCode}&projectCode=${item.projectCode}&version=horiz`)
        } else {
          this.$router.push(`/rencHome?queryParams=`+JSON.stringify(queryParams)+'&pageType=pro')
        } 
      }
      
    }
  },
  destroyed(){ 
    this.realData = [];
  }
};
</script>

<style lang="scss" scoped>
  .ui-pro-box{  
      max-height: 23.75rem;
      // overflow-y: scroll; 
      &::-webkit-scrollbar{
        display: none;
    }
  }
.ui-recent-list{
    cursor: pointer;
    // padding: 1rem;
    border-radius: .75rem;   
}
.dev-addr{
  width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp:1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/RencList.vue